import * as React from 'react';
import type { SVGProps } from 'react';
const IconFileWord = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconFileWord"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      d="m16 2 4 4v16H4V2zm-.828 2H6v16h12V6.828zM9.495 9.07l.69 5.69.96-5.69h1.72l.9 5.69.81-5.69h1.56L14.975 16h-2.13l-.86-5.29-.91 5.29h-2.08l-1.14-6.93z"
    />
  </svg>
);
export default IconFileWord;
